import { BRANDS, DEFAULT_BRAND } from '../config/brands';

// Cache for brand detection to avoid repeated checks
let brandCache = null;

/**
 * Detects the current brand based on query parameter or hostname
 * @returns {Object} Brand configuration object
 */
export function detectBrand() {
  // Return cached result if available
  if (brandCache) {
    return brandCache;
  }

  // Check for brand query parameter first (for local testing)
  const urlParams = new URLSearchParams(window.location.search);
  const brandParam = urlParams.get('brand')?.toLowerCase();

  if (brandParam) {
    // Try to find brand by ID or name from query parameter
    for (const brandKey in BRANDS) {
      const brand = BRANDS[brandKey];
      if (brand.id.toLowerCase() === brandParam || brand.name.toLowerCase() === brandParam) {
        brandCache = brand;
        return brand;
      }
    }
  }

  // Fallback to hostname detection
  const hostname = window.location.hostname.toLowerCase();

  // Search through all brands to find a matching domain
  for (const brandKey in BRANDS) {
    const brand = BRANDS[brandKey];
    const matchedDomain = brand.domains.find((domain) =>
      hostname.includes(domain.toLowerCase())
    );

    if (matchedDomain) {
      brandCache = brand;
      return brand;
    }
  }

  // Default to Claims1 if no match found
  brandCache = DEFAULT_BRAND;
  return DEFAULT_BRAND;
}

/**
 * Clears the brand cache (useful for testing)
 */
export function clearBrandCache() {
  brandCache = null;
}

/**
 * Checks if the current brand matches the specified brand ID
 * @param {string} brandId - Brand ID to check against
 * @returns {boolean} True if current brand matches
 */
export function isBrand(brandId) {
  const currentBrand = detectBrand();
  return currentBrand.id === brandId;
}

/**
 * Returns a value based on the current brand (ternary helper)
 * @param {*} ycmValue - Value to return if YCM is the current brand
 * @param {*} claim1Value - Value to return if Claims1 is the current brand
 * @returns {*} Value based on current brand
 */
export function getBrandValue(ycmValue, claim1Value) {
  const currentBrand = detectBrand();
  return currentBrand.id === 'YCM' ? ycmValue : claim1Value;
}
